// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header {\n  color: var(--job-arrival-instructions-header-color, #888992);\n  margin: 0px;\n}\n\n.arrival-instruction {\n  white-space: pre-wrap;\n  color: #080912;\n  font-weight: 400;\n  font-size: 14px;\n  letter-spacing: -0.03em;\n  margin: 16px 0 0 0;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
